module.exports = __webpack_public_path__ + "img/big_bang.92b908ea.jpg";